import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const LightWeightIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-lightWeight"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 34 68 34 68 0 0 0" />
        <path
          d="M14.4062736 13.8461025C14.544315 13.4193905 15.1151953 13.3859721 15.3175086 13.75294L15.354928 13.8377069 19.6352212 26.3106349 18.6893651 26.6352212 14.895 15.58 11.3218289 26.6296238 10.3703762 26.3218289 14.4062736 13.8461025ZM52.4062736 1.84610252C52.544315 1.4193905 53.1151953 1.38597214 53.3175086 1.75293995L53.354928 1.83770686 57.6352212 14.3106349 56.6893651 14.6352212 52.895 3.58 49.3218289 14.6296238 48.3703762 14.3218289 52.4062736 1.84610252Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <g transform="translate(8 1.986)">
          <path
            d="M38 11.0139C38 14.8799 41.134 18.0139 45 18.0139 48.866 18.0139 52 14.8799 52 11.0139L38 11.0139ZM0 23.0139C0 26.8799 3.134 30.0139 7 30.0139 10.866 30.0139 14 26.8799 14 23.0139L0 23.0139Z"
            fill="#0050B3"
            className={styles.interactiveColor}
          />
          <path
            d="M44.7740018,-0.953719342 C45.3007264,-1.11979038 45.8623483,-0.827422864 46.0284193,-0.300698216 C46.1826282,0.188403243 45.9415507,0.707594654 45.484599,0.91223521 L45.3753982,0.953719342 L7.22639822,12.9817193 C6.69967357,13.1477904 6.1380517,12.8554229 5.97198066,12.3286982 C5.81777184,11.8395968 6.05884932,11.3204053 6.51580098,11.1157648 L6.62500178,11.0742807 L44.7740018,-0.953719342 Z"
            fill="#00000"
            className={styles.defaultColor}
            fillRule="nonzero"
          />
          <path
            d="M29,6.0139 C29,7.6709 27.657,9.0139 26,9.0139 C24.343,9.0139 23,7.6709 23,6.0139 C23,4.3569 24.343,3.0139 26,3.0139 C27.657,3.0139 29,4.3569 29,6.0139"
            fill="#00000"
            className={styles.defaultColor}
          />
          <path
            d="M26,1.0139 C26.5128358,1.0139 26.9355072,1.39994019 26.9932723,1.89727887 L27,2.0139 L27,28.0139 C27,28.5661847 26.5522847,29.0139 26,29.0139 C25.4871642,29.0139 25.0644928,28.6278598 25.0067277,28.1305211 L25,28.0139 L25,2.0139 C25,1.46161525 25.4477153,1.0139 26,1.0139 Z"
            fill="#00000"
            className={styles.defaultColor}
            fillRule="nonzero"
          />
          <path
            d="M20,30.0139 L32,30.0139 L32,30.0139 C32,28.9089 31.105,28.0139 30,28.0139 L22,28.0139 C20.895,28.0139 20,28.9089 20,30.0139 Z"
            fill="#00000"
            className={styles.defaultColor}
          />
        </g>
      </g>
    </Icon>
  )
}
